/** 与侧栏、动态路由一致的设备管理菜单修正 */

export function isHiddenTerminalListMenu(child) {
  if (!child) return false
  const title = (child.meta && child.meta.title) || ''
  const comp = String(child.component || '')
  const path = String(child.path || '')
  if (title === '终端列表') return true
  if (comp.includes('terminal/list')) return true
  return path === 'terminal-list' || path === 'terminal/list'
}

export function patchDeviceMenuMeta(meta) {
  const m = { ...(meta || {}) }
  if (m.title === '终端监控') m.title = '设备监控'
  return m
}

export function normalizeDeviceRouteChildren(children) {
  return (children || [])
    .filter(c => !isHiddenTerminalListMenu(c))
    .map(c => ({
      ...c,
      meta: patchDeviceMenuMeta(c.meta)
    }))
}
